import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import Modal from '../components/Modal';
import ConfirmModal from '../components/ConfirmModal';

const AdminVolunteers = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title: '', description: '', location: '', startDate: '', endDate: '', slots: 1, requirements: '', benefits: '', imageUrl: '', categories: [] });
  const [availableCategories, setAvailableCategories] = useState([]);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [categoryName, setCategoryName] = useState('');
  const [editingCategory, setEditingCategory] = useState(null);
  const [confirmDeleteCat, setConfirmDeleteCat] = useState(null);
  const [deletingCat, setDeletingCat] = useState(false);
  const [categorySaving, setCategorySaving] = useState(false);
  const [editing, setEditing] = useState(null);
  const [registrations, setRegistrations] = useState([]);
  const [showRegs, setShowRegs] = useState(false);

  const load = async (p = 1) => {
    try {
      setLoading(true);
      setError('');
      const res = await axios.get('/api/volunteers', { params: { search, page: p, limit } });
      setItems(res.data.items || []);
      setTotal(res.data.total || 0);
    } catch (e) {
      setError(e?.response?.data?.message || 'Falha ao carregar oportunidades');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(1); loadCategories(); }, []);
  const loadCategories = async () => {
    try {
      const res = await axios.get('/api/volunteer-categories');
      const names = Array.isArray(res.data) ? res.data : [];
      if (names.length) setAvailableCategories(names);
    } catch (e) {
      const msg = e?.response?.data?.message || 'Falha ao carregar categorias';
      setError(msg);
      toast.error(msg);
    }
  };

  const openCreate = () => { setEditing(null); setForm({ title: '', description: '', location: '', startDate: '', endDate: '', slots: 1, requirements: '', benefits: '', imageUrl: '', categories: [] }); setShowForm(true); };
  const openEdit = (item) => { setEditing(item); setForm({ title: item.title, description: item.description, location: item.location, startDate: item.startDate ? item.startDate.substring(0,10) : '', endDate: item.endDate ? item.endDate.substring(0,10) : '', slots: item.slots || 1, requirements: (item.requirements||[]).join(', '), benefits: (item.benefits||[]).join(', '), imageUrl: item.imageUrl || '', categories: item.categories || [] }); setShowForm(true); };
  const submit = async () => {
    try {
      if (!form.title || !form.description || !form.location || !form.startDate || !form.slots) return;
      if (!form.categories || form.categories.length === 0) { setError('Selecione pelo menos uma categoria'); return; }
      const payload = { ...form, requirements: form.requirements ? form.requirements.split(',').map(s=>s.trim()).filter(Boolean) : [], benefits: form.benefits ? form.benefits.split(',').map(s=>s.trim()).filter(Boolean) : [] };
      if (editing) await axios.put(`/api/volunteers/${editing._id}`, payload); else await axios.post('/api/volunteers', payload);
      setShowForm(false);
      await load(page);
    } catch (e) { setError(e?.response?.data?.message || 'Falha ao salvar'); }
  };
  const removeItem = async (id) => { try { await axios.delete(`/api/volunteers/${id}`); await load(page); } catch (e) { setError('Falha ao excluir'); } };
  const openRegistrations = async (id) => { try { const res = await axios.get(`/api/volunteers/${id}/registrations`); setRegistrations(res.data || []); setShowRegs(true); } catch (e) { setError('Falha ao carregar inscrições'); } };
  const updateReg = async (oppId, regId, status) => { try { await axios.put(`/api/volunteers/${oppId}/registrations/${regId}`, { status }); await openRegistrations(oppId); } catch(e){ setError('Falha ao atualizar inscrição'); } };

  const totalPages = Math.max(1, Math.ceil(total / limit));

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <h1 className="text-xl sm:text-2xl font-bold text-primary">Voluntariado</h1>
        <div className="flex items-center gap-2 ml-auto">
          <input className="form-input" placeholder="Buscar oportunidades" value={search} onChange={(e)=>setSearch(e.target.value)} />
          <button className="btn btn-primary" onClick={()=>{ setPage(1); load(1); }} disabled={loading}>{loading ? 'Carregando...' : 'Buscar'}</button>
        </div>
      </div>

      <div className="card">
        <div className="card-header flex items-center justify-between">
          <h2 className="card-title">Categoria</h2>
          <button className="btn btn-secondary" onClick={()=>{ setEditingCategory(null); setCategoryName(''); setShowCategoryModal(true); }} aria-label="Criar Categoria" title="Criar Categoria">Criar Categoria</button>
        </div>
        <div className="card-body p-0">
          <div className="tithers-table-container">
            <table className="tithers-table">
              <thead>
                <tr>
                  <th className="name-column">Nome</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {availableCategories.map((c, idx) => {
                  const name = typeof c === 'object' ? (c.name || '') : c;
                  const key = typeof c === 'object' ? (c._id || c.name || idx) : (c || idx);
                  return (
                    <tr key={key}>
                      <td className="name-column font-medium">{name}</td>
                      <td className="text-right">
                        <div className="flex justify-end gap-2">
                          <button className="btn btn-outline btn-sm" onClick={()=>{ setEditingCategory(c); setCategoryName(name); setShowCategoryModal(true); }}>Editar</button>
                          <button className="btn btn-danger btn-sm" onClick={()=> { setConfirmDeleteCat(c); }}>Excluir</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header flex items-center justify-between">
          <h2 className="card-title">Oportunidades</h2>
          <button className="btn btn-secondary" onClick={openCreate} aria-label="Nova oportunidade" title="Nova oportunidade">Nova</button>
        </div>
        <div className="card-body p-0">
          {loading ? (
            <div className="flex items-center justify-center py-8"><div className="loading" /><span className="ml-2">Carregando...</span></div>
          ) : (
            <div className="tithers-table-container">
              <table className="tithers-table">
                <thead>
                  <tr>
                    <th className="name-column">Título</th>
                    <th>Local</th>
                    <th>Data</th>
                    <th>Vagas</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {items.map(item => (
                    <tr key={item._id}>
                      <td className="name-column font-medium">{item.title}</td>
                      <td>{item.location}</td>
                      <td>{item.startDate ? new Date(item.startDate).toLocaleString('pt-BR') : '-'}</td>
                      <td>{item.registrations?.length || 0} / {item.slots}</td>
                      <td className="text-right">
                        <div className="flex justify-end gap-2">
                          <button className="btn btn-outline btn-sm" onClick={()=>openRegistrations(item._id)}>Inscrições</button>
                          <button className="btn btn-outline btn-sm" onClick={()=>openEdit(item)}>Editar</button>
                          <button className="btn btn-danger btn-sm" onClick={()=>removeItem(item._id)}>Excluir</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="card-footer flex items-center gap-3">
          <button className="btn btn-sm btn-outline" disabled={page<=1 || loading} onClick={()=>{ const p=Math.max(1,page-1); setPage(p); load(p); }}>Anterior</button>
          <span className="text-sm">Página {page} de {totalPages}</span>
          <button className="btn btn-sm btn-outline" disabled={page>=totalPages || loading} onClick={()=>{ const p=Math.min(totalPages,page+1); setPage(p); load(p); }}>Próximo</button>
        </div>
      </div>

      <Modal
        isOpen={showForm}
        onClose={() => setShowForm(false)}
        title={editing ? 'Editar Oportunidade' : 'Nova Oportunidade'}
        size="lg"
        placement="top-right"
        contentAlignCenter
      >
          <div className="space-y-3">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div className="form-group"><label className="form-label">Título</label><input className="form-input" value={form.title} onChange={(e)=>setForm({...form,title:e.target.value})} /></div>
              <div className="form-group"><label className="form-label">Localização</label><input className="form-input" value={form.location} onChange={(e)=>setForm({...form,location:e.target.value})} /></div>
              <div className="form-group"><label className="form-label">Data</label><input type="date" className="form-input" value={form.startDate} onChange={(e)=>setForm({...form,startDate:e.target.value})} /></div>
              <div className="form-group"><label className="form-label">Horário fim</label><input type="date" className="form-input" value={form.endDate} onChange={(e)=>setForm({...form,endDate:e.target.value})} /></div>
              <div className="form-group"><label className="form-label">Vagas</label><input type="number" min="1" className="form-input" value={form.slots} onChange={(e)=>setForm({...form,slots:Number(e.target.value)||1})} /></div>
              <div className="form-group"><label className="form-label">Imagem</label><input className="form-input" value={form.imageUrl} onChange={(e)=>setForm({...form,imageUrl:e.target.value})} /></div>
            </div>
            <div className="form-group">
              <label className="form-label">Categorias</label>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" role="group" aria-label="Categorias de voluntariado">
                {availableCategories.map((c) => {
                  const name = typeof c === 'string' ? c : (c.name || '');
                  const key = (typeof c === 'object' && c._id) ? c._id : name;
                  const checked = form.categories.includes(name);
                  return (
                    <label key={key} className="flex items-center gap-2 p-2 border border-gray-200 rounded-md bg-white">
                      <input type="checkbox" checked={checked} onChange={(e)=>{
                        const isOn = e.target.checked;
                        setForm(prev => ({
                          ...prev,
                          categories: isOn ? [...new Set([...prev.categories, name])] : prev.categories.filter(x => x !== name)
                        }));
                      }} />
                      <span>{name}</span>
                    </label>
                  );
                })}
              </div>
            </div>
            <div className="form-group"><label className="form-label">Descrição</label><textarea className="form-input" value={form.description} onChange={(e)=>setForm({...form,description:e.target.value})} /></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div className="form-group"><label className="form-label">Requisitos</label><input className="form-input" value={form.requirements} onChange={(e)=>setForm({...form,requirements:e.target.value})} placeholder="separe por vírgulas" /></div>
              <div className="form-group"><label className="form-label">Benefícios</label><input className="form-input" value={form.benefits} onChange={(e)=>setForm({...form,benefits:e.target.value})} placeholder="separe por vírgulas" /></div>
            </div>
            <div className="flex gap-2 justify-end">
              <button className="btn btn-outline" onClick={()=>setShowForm(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={submit}>Salvar</button>
            </div>
          </div>
      </Modal>

      {showRegs && (
        <div className="card">
          <div className="card-header"><h2 className="card-title">Inscrições</h2></div>
          <div className="card-body">
            <div className="tithers-table-container">
              <table className="tithers-table">
                <thead><tr><th>Nome</th><th>Email</th><th>Status</th><th></th></tr></thead>
                <tbody>
                  {registrations.map((r, idx) => {
                    const regKey = r._id || `${r.email || 'reg'}-${idx}`;
                    const opp = items.find(i => i.registrations?.some(x => x._id === r._id));
                    const oppId = opp?._id;
                    return (
                      <tr key={regKey}>
                        <td>{r.name}</td><td>{r.email}</td><td>{r.status}</td>
                        <td className="text-right">
                          <div className="flex justify-end gap-2">
                            <button className="btn btn-outline btn-sm" onClick={()=> oppId && updateReg(oppId, r._id, 'approved')}>Aprovar</button>
                            <button className="btn btn-outline btn-sm" onClick={()=> oppId && updateReg(oppId, r._id, 'rejected')}>Rejeitar</button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="flex justify-end"><button className="btn btn-outline" onClick={()=>setShowRegs(false)}>Fechar</button></div>
          </div>
        </div>
      )}

      <Modal isOpen={showCategoryModal} onClose={()=> { if (!categorySaving) setShowCategoryModal(false); }} title={editingCategory ? 'Editar Categoria' : 'Nova Categoria'} size="sm">
        <div className="space-y-3">
          <div className="form-group">
            <label className="form-label">Nome</label>
            <input className="form-input" value={categoryName} onChange={(e)=> setCategoryName(e.target.value)} />
          </div>
          <div className="flex justify-end gap-2">
            <button className="btn btn-outline" onClick={()=> setShowCategoryModal(false)} disabled={categorySaving}>Cancelar</button>
            <button className="btn btn-primary" onClick={async ()=>{ const name = categoryName.trim(); if(!name) { setError('Nome é obrigatório'); toast.error('Nome é obrigatório'); return; } try { setCategorySaving(true); const payload = { name, _id: editingCategory?._id }; const res = await axios.post('/api/volunteer-categories/upsert', payload); toast.success(editingCategory?._id ? 'Categoria atualizada' : 'Categoria criada'); setShowCategoryModal(false); await loadCategories(); } catch (e) { const msg = e?.response?.data?.message || 'Falha ao salvar categoria'; setError(msg); toast.error(msg); } finally { setCategorySaving(false); } }} disabled={categorySaving}>
              {categorySaving ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      </Modal>

      <ConfirmModal 
        isOpen={!!confirmDeleteCat}
        onClose={()=> { setConfirmDeleteCat(null); }}
        onConfirm={async ()=>{
          if (deletingCat) return;
          setDeletingCat(true);
          try {
            const target = confirmDeleteCat;
            const name = typeof target === 'string' ? target : (target?.name || '');
            const id = typeof target === 'object' ? target?._id : null;
            if (id) {
              await axios.delete(`/api/volunteer-categories/${id}`);
            } else if (name) {
              await axios.delete(`/api/volunteer-categories/by-name/${encodeURIComponent(name)}`);
            }
            setConfirmDeleteCat(null);
            await loadCategories();
            toast.success('Categoria excluída');
          } catch (e) {
            const msg = e?.response?.data?.message || 'Falha ao excluir categoria';
            setError(msg);
            toast.error(msg);
          } finally {
            setDeletingCat(false);
          }
        }}
        title="Excluir Categoria"
        message={`Deseja excluir a categoria "${(typeof confirmDeleteCat === 'string') ? confirmDeleteCat : (confirmDeleteCat?.name || '')}"?`}
        confirmText="Excluir"
      />

      {error && (<div className="text-sm text-error" role="alert">{error}</div>)}
    </div>
  );
};

export default AdminVolunteers;
